export const USER_COLOR_ARRAY = [
    {
        light: 'var(--palette-pink-20)',
        dark: 'var(--palette-pink-110)',
    },
    {
        light: 'var(--palette-purple-10)',
        dark: 'var(--palette-purple-100)',
    },
    {
        light: 'var(--palette-blue-10)',
        dark: 'var(--palette-blue-100)',
    },
    {
        light: 'var(--palette-green-10)',
        dark: 'var(--palette-green-100)',
    },
    {
        light: 'var(--palette-magenta-10)',
        dark: 'var(--palette-magenta-90)',
    },
    {
        light: 'var(--palette-orange-20)',
        dark: 'var(--palette-orange-100)',
    },
    {
        light: 'var(--palette-yellow-20)',
        dark: 'var(--palette-yellow-120)',
    },
];

export function calculateUsernameColor (username) {
    const usernameArray = username ? [...username] : [];

    const nameValue = usernameArray.reduce((acc, char) => {
        return char.charCodeAt() + acc;
    }, 0);
    const colorValue = nameValue % USER_COLOR_ARRAY.length;
    const borderColorVariable = `var(--raw-${USER_COLOR_ARRAY[colorValue].dark.slice(6)}`;

    return {
        'background-color': USER_COLOR_ARRAY[colorValue].light,
        'color': USER_COLOR_ARRAY[colorValue].dark,
        'border-color': `rgba(${borderColorVariable}, 0.3)`,
    };
}

export function formatUserFullName ({ first = '', last = '', username = '', fullName = '' }) {
    if (fullName) {
        return fullName;
    }

    if (first && last) {
        return `${first} ${last}`;
    }

    return username;
}
